<div class="container container-projects">
    <h1 id="project-title">Some of my projects</h1>

    <main id="main-projects">

        <mat-card>
            <mat-card-title>
                Efeito Eco
            </mat-card-title>
            <mat-card-content>Marketplace of eco-friendly products. Technologies: HTML, CSS, TypeScript, Angular, jQuery, Bootstrap, Java, Spring.</mat-card-content>
            <mat-card-actions align="end">
                <a href="https://efeitoeco-frontend.vercel.app/" target="_blank">
                    <button mat-raised-button>Site</button>
                </a>
                <a href="https://github.com/efeitoeco" target="_blank" class="second-button">
                    <button mat-raised-button>Code</button>
                </a>
            </mat-card-actions>
        </mat-card>

        <mat-card>
            <mat-card-title>
                Pokedex
            </mat-card-title>
            <mat-card-content>Pokedex app made with 3 public pokemon APIs. Technologies: HTML, CSS, JavaScript.</mat-card-content>
            <mat-card-actions align="end">
                <a href="https://pokedex-gabsschrodinger.vercel.app/" target="_blank">
                    <button mat-raised-button>Site</button>
                </a>
                <a href="https://github.com/gabsschrodinger/pokedex" target="_blank" class="second-button">
                    <button mat-raised-button>Code</button>
                </a>
            </mat-card-actions>
        </mat-card>

        <mat-card>
            <mat-card-title>
                Snake Game
            </mat-card-title>
            <mat-card-content>Classic snake game made during the Digital Innovation One HTML Web Developer. Technologies: HTML, CSS, JavaScript.</mat-card-content>
            <mat-card-actions align="end">
                <a href="https://snake-game-plum.vercel.app/" target="_blank">
                    <button mat-raised-button>Site</button>
                </a>
                <a href="https://github.com/gabsschrodinger/snake-game" target="_blank" class="second-button">
                    <button mat-raised-button>Code</button>
                </a>
            </mat-card-actions>
        </mat-card>

        <mat-card>
            <mat-card-title>
                Product Landing Page
            </mat-card-title>
            <mat-card-content>New Product Landing page made during the freeCodeCamp Responsive Web Design Certification. Technologies: HTML, CSS, JavaScript, Bootstrap.</mat-card-content>
            <mat-card-actions align="end">
                <a href="https://product-landing-page-pi.vercel.app/" target="_blank">
                    <button mat-raised-button>Site</button>
                </a>
                <a href="https://github.com/gabsschrodinger/product-landing-page" target="_blank" class="second-button">
                    <button mat-raised-button>Code</button>
                </a>
            </mat-card-actions>
        </mat-card>

        <mat-card>
            <mat-card-title>
                Caesars Cipher
            </mat-card-title>
            <mat-card-content>Caesars Cipher app made with pure JavaScript during the JavaScript Algorithms and Data Structures Certification. Technologies: JavaScript.</mat-card-content>
            <mat-card-actions align="end">
                <a href="https://github.com/gabsschrodinger/caesars-cipher" target="_blank" class="second-button">
                    <button mat-raised-button>Code</button>
                </a>
            </mat-card-actions>
        </mat-card>

        <mat-card>
            <mat-card-title>
                Contacts API
            </mat-card-title>
            <mat-card-content>API for contacts management with docker compose. Technologies: Java, Spring, Docker.</mat-card-content>
            <mat-card-actions align="end">
                <a href="https://github.com/gabsschrodinger/contatos-api" target="_blank" class="second-button">
                    <button mat-raised-button>Code</button>
                </a>
            </mat-card-actions>
        </mat-card>

    </main>
</div>